export const PUBLIC_INSTANCE_URL = 'https://public.chithi.dev/';
export const DOCS_URL = 'https://docs.chithi.dev'

export const OPENAPI_SERVER = 'https://chithi.dev/api/';
export const OPENAPI_URL = `${OPENAPI_SERVER}openapi.json`;
